import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import { listForRouter } from '@/api/system/menu';
import { traverseRoutes, clearHiddenRoutes } from '@/utils/route';
import { getTranslate } from '@/api/translate';
import { constantRoutes } from '@/router';
import app from './app.js';
var SERVERAPI = process.env.VUE_APP_OKEY_SERVER_API;
var state = {
  routes: [],
  subRouters: [],
  addRoutes: [],
  activeId: ''
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_SUB_ROUTES: function SET_SUB_ROUTES(state, routes) {
    state.subRouters = routes;
    console.log("state.subRouters");
    console.log(state.subRouters);
  },
  CLEAR_SUB_ROUTES: function CLEAR_SUB_ROUTES(state) {
    state.subRouters = [];
  },
  SET_ACTIVE_ID: function SET_ACTIVE_ID(state, activeId) {
    state.activeId = activeId;
  }
};
var actions = {
  getSideMenus: function getSideMenus(_ref) {
    var commit = _ref.commit,
      state = _ref.state;
    return new Promise(function (resolve, reject) {
      listForRouter().then(function (data) {
        var remoteroutes = traverseRoutes(data);
        // const menus = clearHiddenRoutes(data);
        commit('SET_ROUTES', remoteroutes);
        resolve(remoteroutes);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  initSubRouters: function initSubRouters(_ref2, menus) {
    var commit = _ref2.commit,
      state = _ref2.state;
    var addRoutes = state.addRoutes;
    var menusRoutes = addRoutes.filter(function (item) {
      return item.id == menus.id;
    });
    console.log("menusRoutes", menusRoutes);
    if (menusRoutes.length > 0 && menusRoutes[0].children) {
      commit('SET_SUB_ROUTES', menusRoutes[0].children);
    } else {
      commit('SET_SUB_ROUTES', []);
    }
    return menusRoutes;
  },
  clearSubRouters: function clearSubRouters(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    commit('CLEAR_SUB_ROUTES');
    commit('SET_ACTIVE_ID', "");
  },
  setActiveId: function setActiveId(_ref4, id) {
    var commit = _ref4.commit,
      state = _ref4.state;
    commit('SET_ACTIVE_ID', id);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};